export default __webpack_public_path__ + "static/media/ace_of_clubs.f2dd09c0.png";